import React, { useMemo, useState, useEffect } from 'react';
import { Select as AntsSelect, ConfigProvider, Icon } from 'antd';
import classNames from 'classnames';

import { useDebounce } from '../../../hooks';

import styles from './LabeledSelect.module.scss';

const Option = AntsSelect.Option;

export const LabeledSelect = React.forwardRef(({ label, withAsterisks,
  defaultValue,
  options = [],
  onSearch = () => {},
  showSearch,
  disabled,
  onChange,
  withDebounceSearch,
  searchDelay = 0,
  EmptyComponent = <> </>,
  filterOption = (input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0,
  allowClear = true,
  id,
  setValueAsObject = false,
  ...props }, ref) => {
  const hasAsterisks = useMemo(() => {
    if (withAsterisks === false) { return false; }

    return withAsterisks;
  }, []);
  const debounceTime = useMemo(() => (Number.isInteger(withDebounceSearch) ? withDebounceSearch : searchDelay), [
    withDebounceSearch
  ]);
  const [ changedValue, setChangedValue ] = useState('');

  const debouncer = useDebounce(changedValue, debounceTime);
  const handleOnSearch = input => {
    withDebounceSearch ? setChangedValue(input) : onSearch(input);
  };

  useEffect(() => {
    (withDebounceSearch && debouncer) && onSearch(debouncer);
  }, [ debouncer ]);

  return (
    <div
      ref={ ref }
      className={ classNames(styles.selectWrapper) }
    >
      <label
        data-testid={ `${id}-label` }
        className={ styles.label }
        style={ disabled ? { color: '#999', zIndex: '999' } : { color: '#57a7d7' } }
      >
        {`${label}`}
        {hasAsterisks && <span className={ styles.asterisks }>{' *'}</span>}
      </label>
      <div className={ styles.inputField }>
        <ConfigProvider renderEmpty={ () => EmptyComponent }>
          <AntsSelect
            data-testid={ id }
            defaultValue={ defaultValue }
            style={{ width: '100%' }}
            className={ disabled ? styles.isDisabled : '' }
            showSearch={ showSearch }
            onSearch={ handleOnSearch }
            onChange={ (v, p) => {
              if (setValueAsObject) {
                  onChange && onChange(options.find(i => i.value === v), p);
              } else {
              onChange && onChange(v, p);

              }
            } }
            filterOption={ filterOption }
            disabled={ disabled }
            allowClear={ allowClear }
            clearIcon={ <Icon data-testId={ `${id}-clearIcon` } type="close-circle" /> }
            id={ id }
            { ...props }
          >
            {options.map(obj => (
              <Option
                data-testid={ obj.value }
                cpId={ `${id}-${obj.value}` }
                key={ obj.value }
                value={ obj.value }
                className={ styles.option }
              >
                {obj.text}
              </Option>
))}
          </AntsSelect>
        </ConfigProvider>
      </div>
    </div>
  );
});
